<template>
  <div>
    <div></div>
    <!-- Assignment Multi Update Modal Start -->
    <b-button
      style="font-size: 11px"
      @click="AssignmentMultiUpdate()"
      size="sm"
      class="mt-1"
      variant="outline-info"
      ><b>MultiUpdate</b></b-button
    >
    <b-modal
      id="AssignmentMultiUpdate-modal"
      ref="AssignmentMultiUpdate-modal"
      :title="title + mu_jb_series"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-6 row">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Assignment Type : </label>
          </div>
          <div class="col-md-8 mt-2">
            <b class="error" v-if="multiUpdateDetail.shipmentType"
              >{{
                multiUpdateDetail.shipmentType == "1" ||
                multiUpdateDetail.shipmentType == "Sea_Shipment"
                  ? "SEA"
                  : "AIR"
              }}{{ " ( " + multiUpdateDetail.transportType + " )" }}</b
            >
          </div>
        </div>
        <div class="col-md-6 row">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Column Name</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              :list="ColumnNameList"
              v-model="multiUpdateDetail.ColumnName"
              option-value="ColumnNameVal"
              option-text="ColumnNameText"
              placeholder="Select Column Name"
              @input="ChangeColumn(multiUpdateDetail.ColumnName)"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.ColumnName">{{
              multiUpdateDetail.ColumnNameError
            }}</span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'CLIENT'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Client Name</label>
          </div>
          <div class="col-md-8">
            <!-- {{clientList}} -->
            <model-list-select
              :list="clientList"
              id="clientNamenew"
              v-model="multiUpdateDetail.clientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Existing Client Name"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.clientId"
              >{{ multiUpdateDetail.CommonError }}
              <!-- //clientIdError -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'CLIENT'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Client Name</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].clientName">{{
              allAssignmentMultiUpdateData[0].clientName
            }}</span>
          </div>
        </div>

        <!-- Importer Client Start -->
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'Importer Client'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Importer Client</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              :list="clientList"
              id="clientNamenew"
              v-model="multiUpdateDetail.importerClientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Existing Importer Client"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.importerClientId"
              >{{ multiUpdateDetail.CommonError }}
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'Importer Client'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Importer Client</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].clientName">{{
              allAssignmentMultiUpdateData[0].ImporterClient
            }}</span>
          </div>
        </div>
        <!-- Importer Client End -->

          <!-- Exporter Client Start -->
          <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'Exporter Client'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Exporter Client </label>
          </div>
          <div class="col-md-8">
            <model-list-select
              :list="clientList"
              id="clientNamenew"
              v-model="multiUpdateDetail.exporterClientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Existing Exporter Client Name"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.exporterClientId"
              >{{ multiUpdateDetail.CommonError }}
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'Exporter Client'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Exporter Client</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].clientName">{{
              allAssignmentMultiUpdateData[0].ExporterClient
            }}</span>
          </div>
        </div>
        <!-- Exporter Client End -->
        <div
          class="col-md-6 row"
          v-if="
            multiUpdateDetail.ColumnName == 'SHIPPING LINE' &&
            multiUpdateDetail.shipmentType != '2'
          "
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">{{
              multiUpdateDetail.containerInfo == "lcl" ? "Agent Coloder" : "Shipping Line"
            }}</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              v-if="
                multiUpdateDetail.shipmentType == '1' &&
                multiUpdateDetail.multipleContainerType == '15' &&
                multiUpdateDetail.transportType == 'Export' &&
                multiUpdateDetail.assign_job_type
                  ? multiUpdateDetail.assign_job_type.indexOf('TPT') >= 0
                  : multiUpdateDetail.assign_job_type.indexOf('TPT') >= 0 &&
                    multiUpdateDetail.containerInfo == 'lcl'
              "
              :list="$store.getters['common/getAllColoaderList']"
              v-model="multiUpdateDetail.shippingId"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Coloder"
            ></model-list-select>
            <model-list-select
              v-else
              :list="shippingList"
              v-model="multiUpdateDetail.shippingId"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Shipping Line"
            ></model-list-select>

            <span class="error" v-if="!multiUpdateDetail.shippingId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.airportDepartureError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="
            multiUpdateDetail.ColumnName == 'SHIPPING LINE' &&
            multiUpdateDetail.shipmentType != '2'
          "
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName"
              >Old
              {{
                multiUpdateDetail.containerInfo == "lcl"
                  ? "Agent Coloder"
                  : "Shipping Line"
              }}</label
            >
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].shippingLine">{{
              allAssignmentMultiUpdateData[0].shippingLine
            }}</span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'JOB CHANGE'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">JOB</label>
          </div>
          <div
            class="col-md-2"
            v-for="(segmentNameArray, index) in NewshowSegmentArray"
            :key="index"
            :md-flex="segmentNameArray.flex"
            md-flex-small="100"
          >
            <md-checkbox
              v-model="multiUpdateDetail.jobType[index]"
              class="md-primary"
              :md-value="segmentNameArray.value"
              :name="'jobType' + (index + 1)"
              :id="'jobType' + (index + 1)"
              @change="jobTypeSelect(segmentNameArray.value, index)"
              ><b-badge variant="light">{{
                segmentNameArray.value
              }}</b-badge></md-checkbox
            >
            <span class="error" v-if="newJobType.length <= 0">
              {{ multiUpdateDetail.JobTypeError }}
              <!-- {{multiUpdateDetail.handoverLocationIdError}} -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'JOB CHANGE'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old JOB</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].JobTypes">{{
              allAssignmentMultiUpdateData[0].JobTypes
            }}</span>
          </div>
        </div>

        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'JOB CHANGE'">
          <div
            class="col-md-12"
            v-if="
              allAssignmentMultiUpdateData.length > 0 && (
              allAssignmentMultiUpdateData[0].GRDetails ||
              allAssignmentMultiUpdateData[0].Payment_Status ||
              allAssignmentMultiUpdateData[0].subscription_status ||
              allAssignmentMultiUpdateData[0].invoiceNoCreated ||
              allAssignmentMultiUpdateData[0].Note_Details
              )
            "
          >
            <table class="table table-bordered table-sm">
              <thead>
                <tr>
                  <th>SN.</th>
                  <th>Subscription Status</th>
                  <th>Payment Status</th>
                  <th>GRN Details</th>
                  <th>Invoice Details</th>
                  <th>Note Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1.</td>
                  <td>{{ allAssignmentMultiUpdateData.length > 0 ? allAssignmentMultiUpdateData[0].subscription_status : "" }}</td>
                  <td>{{ allAssignmentMultiUpdateData.length > 0 ? allAssignmentMultiUpdateData[0].Payment_Status : "" }}</td>
                  <td>{{ allAssignmentMultiUpdateData.length > 0 ? allAssignmentMultiUpdateData[0].GRDetails : "" }}</td>
                  <td>{{ allAssignmentMultiUpdateData.length > 0 ? allAssignmentMultiUpdateData[0].invoiceNoCreated : "" }}</td>
                  <td>{{ allAssignmentMultiUpdateData.length > 0 ? allAssignmentMultiUpdateData[0].Note_Details : "" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'ENQUIRY ID'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">ENQUIRY ID</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllENQDDList']"
              v-model="multiUpdateDetail.mainEnquiryId"
              option-value="mainEnquiryId"
              option-text="mainEnquirySeries"
              placeholder="Select ENQUIRY No"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.mainEnquiryId">
              {{ multiUpdateDetail.CommonError }}
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'ENQUIRY ID'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old ENQUIRY ID</label>
          </div>
          <div class="col-md-8 mt-2" v-if="allAssignmentMultiUpdateData.length > 0">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].EnquirySeries">{{
              allAssignmentMultiUpdateData[0].EnquirySeries
            }}</span>
          </div>
        </div>

        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'HANDOVER LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Handover Location</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'All', 'getAlllocationHandover')"
              @searchchange="getLocationList($event, 'All', 'getAlllocationHandover')"
              :list="getAlllocationHandover"
              v-model="multiUpdateDetail.handoverLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Handover Location"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.handoverLocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.handoverLocationIdError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'HANDOVER LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Handover Location</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].HOV">{{
              allAssignmentMultiUpdateData[0].HOV
            }}</span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'PICKUP LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Pickup Location</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'All', 'getAlllocationHandover')"
              @searchchange="getLocationList($event, 'All', 'getAlllocationHandover')"
              :list="getAlllocationHandover"
              v-model="multiUpdateDetail.pickupLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Pickup Location"
            ></model-list-select>

            <span class="error" v-if="!multiUpdateDetail.pickupLocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.pickupLocationIdError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'PICKUP LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Pickup Location</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].PICK">{{
              allAssignmentMultiUpdateData[0].PICK
            }}</span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'FACTORY LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Factory Location</label>
          </div>
          
          <!-- :list="allLocationListFactory" -->
          <div class="col-md-8">
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
              v-model="multiUpdateDetail.stuffingLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              :placeholder="
                allLocationList.length > 0 ? 'Select Factory Location' : 'No Factory'
              "
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.stuffingLocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.stuffingLocationIdError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'FACTORY LOCATION'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Factory Location</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].STUF">{{
              allAssignmentMultiUpdateData[0].STUF
            }}</span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'LP'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Load Port Name</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'All', 'PortLoadList')"
              @searchchange="getLocationList($event, 'All', 'PortLoadList')"
              :list="$store.getters['common/getAllPOLList']"
              v-model="multiUpdateDetail.LPlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POL"
            ></model-list-select>
            <!-- <model-list-select
              @input="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_India'
                    : 'Sea_Port_NonIndia',
                  'PortLoadList'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_India'
                    : 'Sea_Port_NonIndia',
                  'PortLoadList'
                )
              "
              :list="PortLoadList"
              v-model="multiUpdateDetail.LPlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Load Port Name"
            ></model-list-select> -->
            <span class="error" v-if="!multiUpdateDetail.LPlocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.LPlocationIdError}} -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'LP'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Load Port Name</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].POL">{{
              allAssignmentMultiUpdateData[0].POL
            }}</span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'POR'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Place of Receipt</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'All', 'IcdPOrtList')"
              @searchchange="getLocationList($event, 'All', 'IcdPOrtList')"
              :list="$store.getters['common/getAllPORList']"
              v-model="multiUpdateDetail.PORlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POR"
            ></model-list-select>
            <!-- <model-list-select
              @input="getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')"
              @searchchange="getLocationList($event, 'Icd,Sea_Port', 'IcdPOrtList')"
              :list="IcdPOrtList"
              v-model="multiUpdateDetail.PORlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Place of Receipt"
            ></model-list-select> -->
            <span class="error" v-if="!multiUpdateDetail.PORlocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{ multiUpdateDetail.PORlocationIdError}} -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'POR'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Place of Receipt</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].POR">{{
              allAssignmentMultiUpdateData[0].POR
            }}</span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'POD'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Port of Discharge</label>
          </div>
          <div class="col-md-8">
            <!-- <model-list-select
              @input="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Sea_Port_India',
                  'getPortDischargeList'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'getPortDischargeList'
                )
              "
              :list="PortDischargeList"
              v-model="multiUpdateDetail.PODLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POD"
            ></model-list-select> -->
            <model-list-select
              @input="
                getLocationList(
                  $event,
                  allAssignmentMultiUpdateData.length > 0 && (allAssignmentMultiUpdateData[0].shipmentType == '1' || allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
                    allAssignmentMultiUpdateData[0].transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'getPortDischargeList'
                )
              "
              @searchchange="
                getLocationList(

                  $event,
                  allAssignmentMultiUpdateData.length > 0 && (allAssignmentMultiUpdateData[0].shipmentType == '1' || allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
                    allAssignmentMultiUpdateData[0].transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'getPortDischargeList'
                )
              "
              :list="PortDischargeList"
              v-model="multiUpdateDetail.PODLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POD"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.PODLocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{ multiUpdateDetail.PODLocationIdError}} -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'POD'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Port of Discharge</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].POD">{{
              allAssignmentMultiUpdateData[0].POD
            }}<br/></span>
             <label for="ColumnName" v-if="allAssignmentMultiUpdateData.length > 0">BL No:{{allAssignmentMultiUpdateData[0].PODBLNO}}</label>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'FPOD'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Final Place of Delivery</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="
                getLocationList(
                  $event,
                  allAssignmentMultiUpdateData.length > 0 && (allAssignmentMultiUpdateData[0].shipmentType == '1' || allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
                    allAssignmentMultiUpdateData[0].transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'finalAllPlaceData'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  allAssignmentMultiUpdateData.length > 0 && (allAssignmentMultiUpdateData[0].shipmentType == '1' || allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
                    allAssignmentMultiUpdateData[0].transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'finalAllPlaceData'
                )
              "
              :list="finalAllPlaceData"
              v-model="multiUpdateDetail.finalPlaceLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select FPOD"
            ></model-list-select>
            <!-- {{$store.getters['common/getAllLocationDetailsFinalList']}} -->
            <!-- <model-list-select
              @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
              @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
              :list="$store.getters['common/getAllLocationDetailsFinalList']"
              v-model="multiUpdateDetail.finalPlaceLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select FPOD"
            ></model-list-select> -->
            <!-- <model-list-select
              @input="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'finalAllPlaceData'
                )
              "
              @searchchange="
                getLocationList(
                  $event,
                  multiUpdateDetail.shipmentType == '1' &&
                    multiUpdateDetail.transportType == 'Export'
                    ? 'Sea_Port_NonIndia'
                    : 'Icd,Sea_Port_India',
                  'finalAllPlaceData'
                )
              "
              :list="finalAllPlaceData"
              v-model="multiUpdateDetail.finalPlaceLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select FPOD"
            ></model-list-select> -->
            <span class="error" v-if="!multiUpdateDetail.finalPlaceLocationId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{ multiUpdateDetail.finalPlaceLocationIdError }} -->
            </span>
          </div>
        </div>
        <div class="col-md-6 row" v-if="multiUpdateDetail.ColumnName == 'FPOD'">
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Final Place of Delivery</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].FPOD">{{
              allAssignmentMultiUpdateData[0].FPOD
            }}</span>
          </div>
        </div>

        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Airport of Destination'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Airport of Destination</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'Air_Port', 'PortLoadList')"
              @searchchange="getLocationList($event, 'Air_Port', 'AirPortLoadList')"
              :list="AirPortLoadList"
              v-model="multiUpdateDetail.airportDestination"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Destination"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.airportDestination">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.airportDestinationError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Airport of Destination'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Airport of Destination</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].airDesti">{{
              allAssignmentMultiUpdateData[0].airDesti
            }}</span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Airport of Departure'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Airport of Departure</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              @input="getLocationList($event, 'Air_Port', 'IcdPOrtList')"
              @searchchange="getLocationList($event, 'Air_Port', 'AirIcdPOrtList')"
              :list="AirIcdPOrtList"
              v-model="multiUpdateDetail.airportDeparture"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Airport Departure"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.airportDeparture">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{multiUpdateDetail.airportDepartureError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Airport of Departure'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Airport of Departure</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].AirDept">{{
              allAssignmentMultiUpdateData[0].AirDept
            }}</span>
          </div>
        </div>

        <div
          class="col-md-6 row"
          v-if="
            multiUpdateDetail.ColumnName == 'Airline' &&
            multiUpdateDetail.shipmentType == '2'
          "
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Airline</label>
          </div>
          <div class="col-md-8">
            <model-list-select
              :list="airLineList"
              v-model="multiUpdateDetail.airlineId"
              option-value="airlineId"
              option-text="airlineName"
              placeholder="Select Airline"
            ></model-list-select>
            <span class="error" v-if="!multiUpdateDetail.airlineId">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{ multiUpdateDetail.airlineIdError}} -->
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="
            multiUpdateDetail.ColumnName == 'Airline' &&
            multiUpdateDetail.shipmentType == '2'
          "
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Airline Name</label>
          </div>
          <div class="col-md-8 mt-2">
            <span class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].airlineName">{{
              allAssignmentMultiUpdateData[0].airlineName
            }}</span>
          </div>
        </div>

        <!-- UpdateCOntainer Type /COntainer NO Start -->
        <div
          class="col-md-12 row"
          v-if="multiUpdateDetail.ColumnName == 'Container Details'"
        >
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="CONTAINERCOUNTArr.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 200px">CONTAINER TYPE</th>
                <th scope="col" style="width: 180px">CONTAINER No</th>
                <th scope="col" style="width: 5px">
                  Actions
                  <!-- <b-button @click="addContainerCount()" size="sm">
                    <i class="fa fa-plus-circle ml-1"></i>
                  </b-button> -->
                </th>
              </tr>
              <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    option-value="containerTypeId"
                    option-text="containerType"
                    v-model="item.containerTypeId"
                    placeholder="Select Container Type"
                    @input="containerTypeChange(item, index)"
                  ></model-list-select>
                  <span class="error" v-if="item.containerTypeId_err ? true : false">{{
                    item.containerTypeId_err
                  }}</span>
                </td>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.containerNo"
                    :disabled="$sessionsStorage.get('nameUser') == 'Bhavneesh' && $sessionsStorage.get('designation') == 'Admin'?false:true"
                    type="text"
                    placeholder="Enter Container No"
                  ></b-form-input>
                  <span class="error" v-if="item.containerNo_err ? true : false">{{
                    item.containerNo_err
                  }}</span>
                </td>

                <td>
                  <b-button
                    v-if="index > 0"
                    size="sm"
                    disabled
                    @click="removeContainerCount(index)"
                  >
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                  <b-button
                    v-if="$sessionsStorage.get('nameUser') == 'Bhavneesh' && $sessionsStorage.get('designation') == 'Admin'"
                    size="sm"
                    class="btn btn-sm btn-success"
                    @click="updateContainerNo(item)"
                  >
                    Update
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- UpdateCOntainer Type /COntainer NO End -->

        <!-- Update Valid Booking NO Start -->
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Booking No (CT JOB)'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Booking No (CT JOB)</label>
          </div>
          <div class="col-md-8">
            <b-form-input
              :formatter="capitalizeAll"
              @input="fetchExistExec"
              id="validBookingNo"
              name="validBookingNo"
              v-model="multiUpdateDetail.validBookingNo"
            ></b-form-input>
            <span class="error" v-if="!multiUpdateDetail.validBookingNo">
              {{ multiUpdateDetail.CommonError }}
              <!-- {{ multiUpdateDetail.validBookingNoError}} -->
            </span>
            <!-- <b-button
              v-if="showSameBookingError"
              style="margin-top: 35px"
              class="ml-2"
              size="sm"
              variant="outline-info"
              @click="showModalExist"
              >Show Executions</b-button
            > -->
            <h5 class="error">{{ showSameBookingError }}</h5>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Booking No (CT JOB)'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Booking No (CT JOB)</label>
          </div>
          <div class="col-md-8 mt-2">
            <b
              class="error"
              v-if="
                allAssignmentMultiUpdateData.length > 0 &&
                allAssignmentMultiUpdateData[0].validBookingNo
              "
            >
              {{ allAssignmentMultiUpdateData[0].validBookingNo }}
            </b>
          </div>
        </div>
        <!-- Update Valid Booking NO End -->

      <!-- Update Container Count Start -->
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Increase Container Count'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Container Count</label>
          </div>
          <div class="col-md-8">
            <b-form-input
              :formatter="capitalizeAll"
              id="multiConNo"
              name="multiConNo"
              v-model="multiUpdateDetail.multiConNo"
            ></b-form-input>
            <span class="error" v-if="!multiUpdateDetail.multiConNo">
              {{ multiUpdateDetail.CommonError }}
            </span>
          </div>
        </div>
        <div
          class="col-md-6 row"
          v-if="multiUpdateDetail.ColumnName == 'Increase Container Count'"
        >
          <div class="col-md-4 text-right">
            <label for="ColumnName">Old Container Count</label>
          </div>
          <div class="col-md-8 mt-2">
            <b class="error" v-if="allAssignmentMultiUpdateData.length > 0 && allAssignmentMultiUpdateData[0].multiConNo">{{
              allAssignmentMultiUpdateData[0].multiConNo
            }}</b>
          </div>
        </div>
        <!-- Update Container Count End -->

        <div class="col-md-12 text-center">
          <center>
            <b-button
              style="font-size: 11px"
              size="sm"
              class="mt-1 ml-1 mr-1"
              variant="success"
              v-if="
                multiUpdateDetail.allModuleId != '' &&
                multiUpdateDetail.ColumnName != '' &&
                this.multiUpdateDetail.NewJobTypesArr.length >= 1
              "
              :disabled="
                multiUpdateDetail.ColumnName == 'JOB CHANGE' && buttonDisable
                  ? true
                  : false
              "
              @click="SaveMultiUpdate"
              >Save</b-button
            >
            <!-- {{ multiUpdateDetail.ColumnName + buttonDisable }} -->
            <!-- multiUpdateDetail.ColumnName == 'JOB CHANGE' &&
                (allAssignmentMultiUpdateData[0].Payment_Status != 'No' ||
                  (allAssignmentMultiUpdateData[0].subscription_status !=
                    'Un-Subscribed' &&
                    allAssignmentMultiUpdateData[0].subscription_status != 'Failed') ||
                  allAssignmentMultiUpdateData[0].invoiceNoCreated ||
                  allAssignmentMultiUpdateData[0].Note_Details ||
                  this.newJobType.length == 0)
                  ? true
                  : false -->
            <!-- (multiUpdateDetail.ColumnName == 'JOB CHANGE' && (allAssignmentMultiUpdateData[0].Payment_Status !='No' || (allAssignmentMultiUpdateData[0].subscription_status!='Un-Subscribed' && allAssignmentMultiUpdateData[0].subscription_status!='Failed') || allAssignmentMultiUpdateData[0].invoiceNoCreated || allAssignmentMultiUpdateData[0].Note_Details || this.newJobType.length==0))?true:false -->
            <!-- allAssignmentMultiUpdateData[0].GRDetails ||  -->
            <b-button
              @click="hideAssignmentMultiUpdate"
              style="font-size: 11px"
              size="sm"
              class="mt-1"
              variant="danger"
            >
              Close</b-button
            >
          </center>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Confirmation"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h4 class="error">Are You Sure Want To Change Job</h4>
      <b-button variant="success" @click="Confirmation('Yes')"> Yes</b-button>
      <b-button @click="Confirmation('No')" variant="danger" class="pull-right">
        No</b-button
      >
    </b-modal>
    <!-- Assignment Summary Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import CommonService from "../../services/CommonService.js";

export default {
  props: [
    "title",
    "mu_assign_date",
    "mu_assign_job_type",
    "mu_assign_raised_from",
    "mu_assign_raised_by",
    "mu_all_module_id",
    "mu_jb_series",
    "mu_client_id",
    "mu_pod_id",
    "mu_shipmentType",
    "mu_transportType",
    "mu_containerInfo",
    "mu_multipleContainerType",
    "mu_clientType",
  ],
  beforeMount() {
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );

    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
         type:'Normal',
        Territory:'',
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );

    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (this.mu_all_module_id != "" && this.Filter_Flag == true) {
      this.getServicesData();
      this.getAssignmentMultiUpdate();
    }
  },

  data() {
    return {
      minusJob: [],
      newJobType: [],
      validateCONC: true,
      CONTAINERCOUNTArr: [
        {
          containerTypeId: "",
          containerType: "",
          uniqueContainerId: "",
          containerNo: "",
          allModuleId: "",

          tptGrnId: "",
          tptGrnAssignmentId: "",
          isContainerActive: "",
          isContainerremove: "",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      allAssignmentMultiUpdateData: [],
      all_module_id: this.mu_all_module_id,
      Filter_Flag: false,
      ContainerDetails: [],
      NewshowSegmentArray: [],
      showSameBookingError: "",
      checkstatus: "0",
      allExistingData: [],
      getAllActiveContainerList: [],
      multiUpdateDetail: {
        showSegmentArray: [],
        NewshowSegmentArray: [],
        jobType: [],
        NewJobTypesArr: [],
        allModuleId: this.mu_all_module_id,
        ColumnName: "",
        mainEnquiryId: "",
        handoverLocationId: "",
        pickupLocationId: "",
        validBookingNo: "",
        multiConNo:"",
        stuffingLocationId: "",
        shippingId: "",
        clientId: "",
        exporterClientId:"",
        importerClientId:"",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        exporterClientId: "",
        importerClientId: "",
        airportDeparture: "",
        airportDestination: "",
        airlineId: "",
        containerDetails: [],
        containerCountDetails: "",
        shipmentType: this.mu_shipmentType,
        transportType: this.mu_transportType,
        clientType: this.mu_clientType,
        assign_job_type: this.mu_assign_job_type,
        jb_series: this.mu_jb_series,
        containerInfo: this.mu_containerInfo,
        multipleContainerType: this.mu_multipleContainerType,

        CommonError: "",
        ColumnNameError: "",
        JobTypeError: "",
        mainEnquiryIdError: "",
        handoverLocationIdError: "",
        pickupLocationIdError: "",
        validBookingNoError: "",
        multiConNoError:"",
        stuffingLocationIdError: "",
        shippingIdError: "",
        clientIdError: "",
        exporterClientIdError: "",
        importerClientIdError: "",
        PORlocationIdError: "",
        LPlocationIdError: "",
        PODLocationIdError: "",
        finalPlaceLocationIdError: "",
        exporterClientIdError: "",
        importerClientId: "",
        airportDepartureError: "",
        airportDestinationError: "",
        airlineIdError: "",
        containerDetailsError: "",
      },

      ColumnNameList: [
        {
          ColumnNameVal: "JOB CHANGE",
          ColumnNameText: "SERVICE CHANGE",
        },
        {
          ColumnNameVal: "HANDOVER LOCATION",
          ColumnNameText: "HANDOVER LOCATION",
        },
        {
          ColumnNameVal: "ENQUIRY ID",
          ColumnNameText: "ENQUIRY ID",
        },
        {
          ColumnNameVal: "PICKUP LOCATION",
          ColumnNameText: "PICKUP LOCATION",
        },
        {
          ColumnNameVal: "FACTORY LOCATION",
          ColumnNameText: "FACTORY LOCATION",
        },
        {
          ColumnNameVal: "LP",
          ColumnNameText: "LP",
        },
        {
          ColumnNameVal: "POR",
          ColumnNameText: "POR",
        },
        {
          ColumnNameVal: "POD",
          ColumnNameText: "POD",
        },
        {
          ColumnNameVal: "FPOD",
          ColumnNameText: "FPOD",
        },
        {
          ColumnNameVal: "SHIPPING LINE",
          ColumnNameText: "SHIPPING LINE",
        },
        {
          ColumnNameVal: "CLIENT",
          ColumnNameText: "CLIENT",
        },
        {
          ColumnNameVal: "Importer Client",
          ColumnNameText: "Importer Client",
        },
        {
          ColumnNameVal: "Exporter Client",
          ColumnNameText: "Exporter Client",
        },
        {
          ColumnNameVal: "Booking No (CT JOB)",
          ColumnNameText: "Booking No (CT JOB)",
        },{
          ColumnNameVal: "Increase Container Count",
          ColumnNameText: "Increase Container Count",
        },
        // {
        //   ColumnNameVal: "Airport of Destination",
        //   ColumnNameText: "Airport of Destination",
        // },
        // {
        //   ColumnNameVal: "Airport of Departure",
        //   ColumnNameText: "Airport of Departure",
        // },
        {
          ColumnNameVal: "Airline",
          ColumnNameText: "Airline",
        },
        {
          ColumnNameVal: "Container Details",
          ColumnNameText: "Container Details",
        },
      ],
      getlocationListData: [],
      getAlllocationListData: [],
      getAlllocationListDataFactory: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],
      finalAllPlaceData: [],
      getShippingLineData: [],
      getColoaderNameList: [],
      getPortDischargeList: [],
      getlocationListData: ["agra"],
      getAlllocationListData: [],
      handoverListData: [],
      getAlllocationListDataFactory: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],
      AirIcdPOrtList: [],

      PortLoadList: [],
      AirPortLoadList: [],
      getCLientData: [],
      getImporterExpo: [],
      factoryDetail: [],
      airLineList: [],
      buttonDisable: false,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {
    clientList() {
      return this.getCLientData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },
    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    addContainerCount() {
      let obj = {
        containerTypeId: "",
        containerType: "",
        uniqueContainerId: "",
        containerNo: "",
        allModuleId: "",

        tptGrnId: "",
        tptGrnAssignmentId: "",
        isContainerActive: "",
        isContainerremove: "",
      };
      this.CONTAINERCOUNTArr.push(obj);
    },
    removeContainerCount(index) {
      this.CONTAINERCOUNTArr.splice(index, 1);
    },
    validateCONCDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.CONTAINERCOUNTArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].cont_type == "") {
          this.CONTAINERCOUNTArr[j].cont_type_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_type_err = "";
          validate_new = true;
        }

        if (MainARR[j].cont_count == "") {
          this.CONTAINERCOUNTArr[j].cont_count_err =
            "Container Count " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.CONTAINERCOUNTArr[j].cont_count_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },

    updateContainerNo(item){
      this.isLoading = true;
      console.log("item=>",item);
      // return false;
      let payload = {
        filter: "updateContainer",
        allModuleId: item.allModuleId,
        uniqueContainerId:item.uniqueContainerId,
        containerNo:item.containerNo,
        containerTypeId:item.containerTypeId,
        containerType:item.containerType,
      };
      CommonService.getAllCreditDebitNoteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.hideAssignmentMultiUpdate();
          if (status == 200 && data.ContFLAG == 1) {
            this.alert.content = data.ContMSG;
          } else {
            this.alert.content = data.ContMSG;
          }
          this.$refs["addPop"].open();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    
    },

    Confirmation(confirm) {
      if (confirm == "Yes") {
        if (this.minusJob.length > 0) {
          this.buttonDisable = false;
        }
      }

      this.$refs["modal-close-conf"].hide();
    },
    jobTypeSelect(value, index) {
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
        // this.minusJob.splice(i, 1);
        this.minusJob.push(value);
      } else {
        this.newJobType.push(value);
        // this.minusJob.push(value);
        this.minusJob.splice(i, 1);
      }
      // this.multiUpdateDetail.jobType = this.newJobType;
      // console.log(this.newJobType);
      // console.log(this.multiUpdateDetail.jobType);//, this.minusJob
      this.getConfirmationAlertJobChange(this.newJobType, this.minusJob);
    },
    getServicesData() {
      this.multiUpdateDetail.showSegmentArray = [
        {
          value: "FF",
          show: "FREIGHT FORWARDING (FF)",
          flex: "25",
        },
        {
          value: "CC",
          show: "CUSTOM CLEARANCE (CC)",
          flex: "25",
        },
        {
          value: "TPT",
          show: "TRANSPORTATION (TPT)",
          flex: "25",
        },
      ];
    },
    getDataLocations() {
      this.getPortDischargeList = this.$store.getters["common/getAllPODList"];
      this.finalAllPlaceData = this.$store.getters[
        "common/getAllLocationDetailsFinalList"
      ];
      if (
        this.allAssignmentMultiUpdateData.length > 0 &&
        this.allAssignmentMultiUpdateData[0].shipmentType != "" &&
        this.allAssignmentMultiUpdateData[0].transportType != ""
      ) {
        this.oldTransport = this.allAssignmentMultiUpdateData[0].transportType;
        this.oldShipment = this.allAssignmentMultiUpdateData[0].shipmentType;
        let vehicle_drive = {
          shipmentType: this.allAssignmentMultiUpdateData[0].shipmentType,
          transportType: this.allAssignmentMultiUpdateData[0].transportType,
          clientType: this.allAssignmentMultiUpdateData[0].clientType,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/getDataEnquiryLocations.php`,
          data: JSON.stringify(vehicle_drive),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.LocationDetailsTransport.length > 0) {
                this.getAlllocationListData = data.LocationDetailsTransport;
                this.handoverListData = data.LocationDetailsTransport;
              }
              if (data.LocationDetailsIcdIndiaSea.length > 0) {
                this.IcdPOrtList = data.LocationDetailsIcdIndiaSea;
              }

              if (data.LocationDetailsIndiaSea.length > 0) {
                this.PortLoadList = data.LocationDetailsIndiaSea;
              }

              if (data.LocationDetailsSeaPortsNotIndia.length > 0) {
                this.getPortDischargeList = data.LocationDetailsSeaPortsNotIndia;
                this.finalAllPlaceData = data.LocationDetailsSeaPortsNotIndia;
              }

              if (data.LocationDetailsClientFac.length > 0) {
                this.tempFactoryData = data.LocationDetailsClientFac;
                this.getAlllocationListDataFactory = data.LocationDetailsClientFac;
              }
              if (data.LocationDetailsAirPorts.length > 0) {
                this.AirPortLoadList = data.LocationDetailsAirPorts;
                this.AirIcdPOrtList = data.LocationDetailsAirPorts;
              }
            }
          })
          .catch((error) => {});
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    AssignmentMultiUpdate() {
      this.Filter_Flag = true;
      this.NewshowSegmentArray = [];
      this.newJobType = [];
      this.getAllActiveContainerList = [];

      this.multiUpdateDetail = {
        showSegmentArray: [],
        NewshowSegmentArray: [],
        jobType: [],
        NewJobTypesArr: [],
        allModuleId: this.mu_all_module_id,
        ColumnName: "",
        mainEnquiryId: "",
        handoverLocationId: "",
        pickupLocationId: "",
        validBookingNo: "",
        multiConNo:"",
        stuffingLocationId: "",
        shippingId: "",
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        exporterClientId: "",
        importerClientId: "",
        airportDeparture: "",
        airportDestination: "",
        airlineId: "",
        containerDetails: [],
        containerCountDetails: "",
        shipmentType: this.mu_shipmentType,
        transportType: this.mu_transportType,
        clientType: this.mu_clientType,
        assign_job_type: this.mu_assign_job_type,
        jb_series: this.mu_jb_series,
        containerInfo: this.mu_containerInfo,
        multipleContainerType: this.mu_multipleContainerType,

        CommonError: "",
        ColumnNameError: "",
        JobTypeError: "",
        mainEnquiryIdError: "",
        handoverLocationIdError: "",
        pickupLocationIdError: "",
        validBookingNoError: "",
        multiConNoError:"",
        stuffingLocationIdError: "",
        shippingIdError: "",
        clientIdError: "",
        PORlocationIdError: "",
        LPlocationIdError: "",
        PODLocationIdError: "",
        finalPlaceLocationIdError: "",
        exporterClientIdError: "",
        importerClientId: "",
        airportDepartureError: "",
        airportDestinationError: "",
        airlineIdError: "",
        containerDetailsError: "",
      };
      this.$refs["AssignmentMultiUpdate-modal"].show();
      this.getAssignmentDetails();
    },
    hideAssignmentMultiUpdate() {
      this.Filter_Flag = false;
      this.$refs["AssignmentMultiUpdate-modal"].hide();
    },
    getAssignmentDetails() {
      if (
        (this.mu_all_module_id != "" ||
        this.mu_all_module_id != undefined ||
        this.mu_all_module_id != null)&&
        (this.mu_client_id != "" ||
        this.mu_client_id != undefined ||
        this.mu_client_id != null)
      ) {
        // alert(this.mu_client_id);
        this.$store.dispatch(
          "commonDropdownMaster/setAllENQDDList",
          JSON.stringify({
            itemCode: "ENQList",
            client_id: this.mu_client_id,
          })
        );
        let AssignmentMultiUpdate = {
          filter: "getAssignmentMultiUpdate",
          allModuleId: this.mu_all_module_id,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentMultiUpdateDetails.php`,
          data: JSON.stringify(AssignmentMultiUpdate),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // console.log("data=>", data);

              this.getServicesData();
              if (this.multiUpdateDetail.showSegmentArray.length > 0) {
                if (data.AssignmentSummaryData.length > 0) {
                  this.allAssignmentMultiUpdateData = data.AssignmentSummaryData;
                  this.multiUpdateDetail.jobType = this.allAssignmentMultiUpdateData[0].JobTypes;
                  this.multiUpdateDetail.NewJobTypesArr = this.allAssignmentMultiUpdateData[0].NewJobTypesArr;
                  this.newJobType = this.allAssignmentMultiUpdateData[0].NewJobTypesArr;
                  this.buttonDisable =
                    this.allAssignmentMultiUpdateData[0].Payment_Status != "No" ||
                    (this.allAssignmentMultiUpdateData[0].subscription_status !=
                      "Un-Subscribed" &&
                      this.allAssignmentMultiUpdateData[0].subscription_status !=
                        "Failed") ||
                    this.allAssignmentMultiUpdateData[0].invoiceNoCreated ||
                    this.allAssignmentMultiUpdateData[0].Note_Details ||
                    this.allAssignmentMultiUpdateData[0].GRDetails ||
                    this.newJobType.length == 0
                      ? true
                      : false;
                }
                if (data.airLineList.length > 0) {
                  this.airLineList = data.airLineList;
                }

                if (data.slineDetails.length > 0) {
                  this.getShippingLineData = data.slineDetails;
                } else {
                  this.getShippingLineData = [];
                }

                if (data.clientdetail.length > 0) {
                  this.getCLientData = data.clientdetail;
                } else {
                  this.getCLientData = [];
                }

                if (data.factoryDetail.length > 0) {
                  this.factoryDetail = data.factoryDetail;
                } else {
                  this.factoryDetail = [];
                }

                this.getAlllocationListData = data.LocationDetailsFinal;
                this.getAlllocationHandover = data.LocationDetailsFinal;
                this.getPortDischargeList = data.LocationDetailsSEAPORT;
                this.PortLoadList = data.LocationDetailsSEAPORT;
                this.AirPortLoadList = data.LocationDetailsFinal;
                this.AirIcdPOrtList = data.LocationDetailsFinal;
                this.finalAllPlaceData = data.LocationDetailsFinal;
                this.IcdPOrtList = data.LocationDetailsSEAPORT;

                if (data.factoryDetail.length > 0) {
                  this.tempfactoryDetail = data.factoryDetail;
                  this.getAlllocationListDataFactory = data.factoryDetail;
                }
                this.JqueryFun();
              }
            }
          })
          .catch((error) => {});
      }
    },
    ChangeColumn(item) {
      console.log("this.multiUpdateDetail=>", this.multiUpdateDetail);
      if (item == "JOB CHANGE") {
        if (
          this.multiUpdateDetail.NewJobTypesArr.length > 0 &&
          this.multiUpdateDetail.showSegmentArray.length > 0
        ) {
          // console.log(this.multiUpdateDetail.NewJobTypesArr)
          this.multiUpdateDetail.showSegmentArray.forEach((element1) => {
            this.multiUpdateDetail.NewJobTypesArr.forEach((element) => {
              // alert(element1.value);
              // alert(element);
              if (element1.value == element) {
                let newObj = {};
                newObj = {
                  value: element1.value,
                  show: element1.show,
                  flex: element1.flex,
                };
                this.NewshowSegmentArray.push(newObj);
              }
            });
          });
        }
      }
      if (item == 'FACTORY LOCATION') {
        console.log('this.allAssignmentMultiUpdateData=>',this.allAssignmentMultiUpdateData)
      this.$store.dispatch(
          "commonDropdownMaster/setAllStuffingDDList",
          JSON.stringify({
            itemCode: "AllStuffingList",
          clientId: this.allAssignmentMultiUpdateData.length > 0 ? this.allAssignmentMultiUpdateData[0].clientId : "",
          })
        );
      }
      this.getDataLocations();
      if (item == "Container Details") {
        this.getConatinerDetails();
      }
    },
    containerTypeChange(item, index) {
      // Containers Data Start

      this.$store.getters["common/getAllContainerTypeList"].forEach((ele, ind) => {
        this.CONTAINERCOUNTArr.forEach((ele1, ind1) => {
          if (index == ind1) {
            if (item.containerTypeId == ele.containerTypeId) {
              ele1.containerType = ele.containerType;
            }
          }
        });
      });

      let result2;
      const counts2 = this.CONTAINERCOUNTArr.reduce((accumulator, item) => {
        if (item.containerTypeId && item.containerType) {
          const key = `${item.containerTypeId}-@#${item.containerType}`;
          if (accumulator[key]) {
            accumulator[key].count++;
          } else {
            accumulator[key] = {
              count: 1,
            };
          }
          return accumulator;
        }
      }, {});

      if (counts2) {
        result2 = Object.entries(counts2).map(([containerTypeId, containerType]) => {
          const [k, v] = containerTypeId.split("-@#");
          return {
            key: k,
            value: v,
            containerType: Number(k),
            count: containerType.count,
          };
        });
        this.$forceUpdate();
        this.multiUpdateDetail.containerCountDetails = result2;
        this.multiUpdateDetail.containerDetails = this.CONTAINERCOUNTArr;
        console.log("result2=>", result2);
        console.log("this.CONTAINERCOUNTArr=>", this.CONTAINERCOUNTArr);
      }
      // Containers Data End
    },
    getConatinerDetails() {
      this.isLoading = true;
      let payload = {
        filter: "getAllActiveContainerList",
        allModuleId: this.mu_all_module_id,
      };
      CommonService.getAllCreditDebitNoteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getAllActiveContainerList.length > 0) {
              this.getAllActiveContainerList = data.getAllActiveContainerList;
              console.log(" getAllActiveContainerList response=>", data);
              this.CONTAINERCOUNTArr = [];
              this.getAllActiveContainerList.forEach((ele) => {
                let obj = {
                  containerTypeId: ele.containerTypeId,
                  containerType: ele.containerType,
                  uniqueContainerId: ele.uniqueContainerId,
                  containerNo: ele.containerNo,
                  allModuleId: ele.allModuleId,

                  tptGrnId: ele.tptGrnId,
                  tptGrnAssignmentId: ele.tptGrnAssignmentId,
                  isContainerActive: ele.isContainerActive,
                  isContainerremove: ele.isContainerremove,
                };
                this.CONTAINERCOUNTArr.push(obj);
              });
              // Containers Data Start
              let result2;
              const counts2 = this.CONTAINERCOUNTArr.reduce((accumulator, item) => {
                if (item.containerTypeId && item.containerType) {
                  const key = `${item.containerTypeId}-@#${item.containerType}`;
                  if (accumulator[key]) {
                    accumulator[key].count++;
                  } else {
                    accumulator[key] = {
                      count: 1,
                    };
                  }
                  return accumulator;
                }
              }, {});

              if (counts2) {
                result2 = Object.entries(counts2).map(
                  ([containerTypeId, containerType]) => {
                    const [k, v] = containerTypeId.split("-@#");
                    return {
                      key: k,
                      value: v,
                      containerType: Number(k),
                      count: containerType.count,
                    };
                  }
                );
                console.log("result2=>", result2);
                this.multiUpdateDetail.containerCountDetails = result2;
                this.multiUpdateDetail.containerDetails = this.CONTAINERCOUNTArr;
              }
              // Containers Data End
            }
          } else {
            this.getAllActiveContainerList = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },
    getConfirmationAlertJobChange(newJobType, minusJob) {
      console.log("this.NewshowSegmentArray=>", this.NewshowSegmentArray);
      console.log("this.newJobType=>", this.newJobType);
      console.log("minusJob=>", minusJob);
      if (this.newJobType.length > 0) {
        this.minusJob = [];
        this.NewshowSegmentArray.forEach((n_ele) => {
          this.newJobType.forEach((j_ele) => {
            if (n_ele.value != j_ele) {
              this.minusJob.push(n_ele.value);
            }
          });
        });
      } else {
        this.minusJob = minusJob;
      }
      console.log("this.minusJob=>", this.minusJob);
      let payload = {
        filter: "ConfirmationMultiUpdate",
        JobType: this.minusJob,
        transportType: this.multiUpdateDetail.transportType,
        shipmentType:
          this.multiUpdateDetail.shipmentType == 1 ||
          this.multiUpdateDetail.shipmentType == "Sea_Shipment"
            ? "Sea"
            : "Air",
        allModuleId: this.multiUpdateDetail.allModuleId,
        NewshowSegmentArray: this.multiUpdateDetail.NewshowSegmentArray,
      };
      this.$refs["modal-close-conf"].show();
      console.log("payload=>", payload);
      // return false;
      // JSON.stringify();
      // await //return false;
      // LeadService.getMultiUpdate(payload)
      //   .then((response) => {
      //     const { data, status, statusText } = response;
      //     if (status == 200 && data) {
      //       this.CDCRARR = data.overseasAgentSOA_data;
      //       this.totalRows = data.overseasAgentSOA_data.length;
      //       console.log(" Overseas_Agent_SOA response=>", data);
      //     } else {
      //       this.CDCRARR = [];
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("Catch on Overseas_Agent_SOA Error: ", error);
      //   });
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    allLocationListFactory() {
      return this.getAlllocationListDataFactory;
    },
    PortList() {
      return this.getPortData;
    },
    fetchExistExec() {
      let new_data = {
        validBookingNo: this.multiUpdateDetail.validBookingNo,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchSameExecBookingNo.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          console.log(result.data.status, "uy");
          if (result.data.status == "400") {
            this.showSameBookingError = "No Already Linked With Other Assignment";
            this.checkstatus = "0";
          } else {
            this.showSameBookingError = "";
            this.checkstatus = "0";
            console.log(this.showSameBookingError, "u");
          }
          if (result.data.allExistingData.length > 0) {
            this.allExistingData = result.data.allExistingData;
          }
        })
        .catch((error) => {});
    },
    SaveMultiUpdate() {
      if (
        this.multiUpdateDetail.ColumnName == "" ||
        this.multiUpdateDetail.ColumnName == undefined ||
        this.multiUpdateDetail.ColumnName == null
      ) {
        this.multiUpdateDetail.ColumnNameError = "Please Select Column Name";
        return false;
      }

      if (this.newJobType.length <= 0) {
        this.multiUpdateDetail.JobTypeError = "Please Select Atleast One Job Type";
        return false;
      }

      if (
        this.multiUpdateDetail.mainEnquiryId == "" &&
        this.multiUpdateDetail.handoverLocationId == "" &&
        this.multiUpdateDetail.pickupLocationId == "" &&
        this.multiUpdateDetail.validBookingNo == "" &&
        this.multiUpdateDetail.stuffingLocationId == "" &&
        this.multiUpdateDetail.shippingId == "" &&
        (this.multiUpdateDetail.clientId == "" &&
        this.multiUpdateDetail.exporterClientId == "" &&
        this.multiUpdateDetail.importerClientId == "") &&
        this.multiUpdateDetail.PORlocationId == "" &&
        this.multiUpdateDetail.LPlocationId == "" &&
        this.multiUpdateDetail.PODLocationId == "" &&
        this.multiUpdateDetail.finalPlaceLocationId == "" &&
        this.multiUpdateDetail.airportDeparture == "" &&
        this.multiUpdateDetail.airportDestination == "" &&
        this.multiUpdateDetail.airlineId == "" &&
        this.multiUpdateDetail.jobType == "" &&
         this.multiUpdateDetail.multiConNo == "" &&
        this.multiUpdateDetail.containerDetails.length > 0
      ) {
        this.multiUpdateDetail.CommonError =
          "Please Select " + this.multiUpdateDetail.ColumnName;
        return false;
      }

      if (
        this.mu_all_module_id != "" ||
        this.mu_all_module_id != undefined ||
        this.mu_all_module_id != null
      ) {
        this.multiUpdateDetail.jobType = this.newJobType;
        let AssignmentMultiUpdate = {
          filter: "SubmitAssignmentMultiUpdate",
          allModuleId: this.mu_all_module_id,
          multiUpdateDetail: this.multiUpdateDetail,
        };
        console.log("AssignmentMultiUpdate=>", AssignmentMultiUpdate);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentMultiUpdateDetails.php`,
          data: JSON.stringify(AssignmentMultiUpdate),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 2) {
                this.alert.content = data.MSG;
                this.$router.push({
                  path: "/viewAllModuleDetails/viewAllModuleDetails",
                });
                this.hideAssignmentMultiUpdate();
                this.$refs["addPop"].open();
              } else {
                this.alert.content = data.MSG;
              }

              // this.isLoading = false;
              this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// multiUpdate.vue?3d322f24